"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UrlToJWT = void 0;
var ssrAlgo_1 = require("./code/ssrAlgo");
var ssrData_1 = require("./config/ssrData");
var constant_1 = require("./config/constant");
var axios_1 = require("axios");
var UrlToJWT = /** @class */function () {
  function UrlToJWT(authUrl, channelHash, ssrData) {
    this.authUrl = authUrl;
    constant_1.headers.channel_hash = channelHash;
    ssrData_1.ssrDataJson.api_data = ssrData.api_data;
    ssrData_1.ssrDataJson.synonyms = ssrData.synonyms;
    this.refreshToken();
  }
  UrlToJWT.prototype.refreshToken = function () {
    var _this = this;
    setInterval(function () {
      _this.getAuthData().then(function (response) {
        //console.log("refresh called");
        _this.authData = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    }, 600000);
  };
  UrlToJWT.prototype.getAuthData = function () {
    //console.log(headers);
    var request = axios_1.default.post(this.authUrl, {}, {
      headers: constant_1.headers
    });
    return request;
  };
  UrlToJWT.prototype.setAuthDataPromise = function (requestUrl) {
    var _this = this;
    return this.getAuthData().then(function (response) {
      // console.log("completed Successfully");
      _this.authData = response.data;
      return _this.authData;
    }).then(function (data) {
      return _this.getJWTToken(requestUrl);
    }).catch(function (error) {
      console.log(error);
    });
  };
  UrlToJWT.prototype.getToken = function (requestUrl) {
    var _this = this;
    if (this.authData) {
      var p = new Promise(function (resolve, reject) {
        var token = _this.getJWTToken(requestUrl); // some time consuming work
        if (token) {
          //invoke resolve function passed
          resolve(token);
        }
      });
      return p;
    } else {
      return this.setAuthDataPromise(requestUrl);
      //console.log("Direct Call not allowed, Auth promise pending");
    }
  };
  UrlToJWT.prototype.getJWTToken = function (requestUrl) {
    var token = ssrAlgo_1.SSRDataUtilities.processSingleSSRData(this.authData, ssrData_1.ssrDataJson, requestUrl);
    return token;
  };
  return UrlToJWT;
}();
exports.UrlToJWT = UrlToJWT;